<template>

  <div>
    <div class="columns is-multiline">

      <div class="column is-full-mobile is-one-third-tablet is-one-third-desktop" v-for="tournament in tournaments">

        <div class="card" style="margin: 10px 0 12px 0; text-align: left;">

          <div class="card-header">
            <p class="card-header-title" @click="visitTournament(tournament.id)" style="cursor: pointer;">{{ tournament.name }}</p>
          </div>

          <div class="card-content">
            <p>Date of tournament: {{ tournament.startTime.substring(0, tournament.startTime.indexOf(' at ')) }}</p>
            <p>Organizer: {{ tournament.organizer }}</p>
            <p>Facility: {{ tournament.numCourts }} courts</p>

            <div style="text-align: right; margin-top: 19px;">
              <router-link :to="'/tournaments/' + tournament.id" class="button is-danger is-outlined is-small">Dashboard</router-link> &nbsp;
              <router-link :to="'/tournaments/' + tournament.id + '/matches'" class="button is-primary is-outlined is-small">Matches</router-link>
            </div>
          </div>

        </div>

      </div>

    </div>

    <div class="columns">
        <div class="column is-full-desktop" style="text-align: right;">
          <router-link class="button is-danger is-medium" to="/tournaments/add">Add tournament</router-link>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  computed: {
    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {

    visitTournament(id) {
      this.$router.push('/tournaments/' + id);
    }

  },

  name: 'tournaments'
}
</script>



<style scoped>

</style>